module.exports = __webpack_public_path__ + "static/garden1-76a621cd8aeff8406168c4aa29f2d30d.jpg";